import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { TMenuAction } from '@dss-libs/shared/type/common-types';

/**
 * Action menu panel. The trigger lives in the consumer template and points at
 * {@link MenuComponent.matMenu}, so a single panel can serve every row of a table.
 */
@Component({
  selector: 'dss-libs-ui-menu',
  imports: [MatMenu, MatMenuItem, MatIcon, TranslocoDirective],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent<A> {
  readonly menuActions = input<TMenuAction<A>[]>([]);
  readonly actionOutput = output<A>();

  readonly matMenu = viewChild.required(MatMenu);
}
